import { Commune_Base, District_Base, Province_Base } from '../models/Administrative';
import { getAxiosInstance } from '../../react/utils/networkUtil';

// get list
export const remote_getAllProvinces = async (): Promise<Array<Province_Base>> => {
  const response = await getAxiosInstance().get('/api/provinces');
  const provinces: any = response.data;
  return provinces;
};

export const remote_getDistricts = async (province_gid_1: string): Promise<Array<District_Base>> => {
  const response = await getAxiosInstance().get(`/api/districts/${province_gid_1}`);
  const provinces: any = response.data;
  return provinces;
};

export const remote_getCommunes = async (district_gid_1: string): Promise<Array<Commune_Base>> => {
  const response = await getAxiosInstance().get(`/api/communes/${district_gid_1}`);
  const provinces: any = response.data;
  return provinces;
};
// end get list

// get one
export const remote_getProvinceById = async (province_gid_1: string): Promise<Province_Base> => {
  const response = await getAxiosInstance().get(`/api/province/${province_gid_1}`);
  const provinces: any = response.data;
  return provinces;
};

export const remote_getDistrictById = async (district_gid_2: string): Promise<District_Base> => {
  const response = await getAxiosInstance().get(`/api/district/${district_gid_2}`);
  const provinces: any = response.data;
  return provinces;
};

export const remote_getCommuneById = async (commune_gid_3: string): Promise<Commune_Base> => {
  const response = await getAxiosInstance().get(`/api/commune/${commune_gid_3}`);
  const provinces: any = response.data;
  return provinces;
};
// get one
